module.exports = __webpack_public_path__ + "static/media/icon-non-employee.7e3ae8a2.png";